import React from "react";
import { IonIcon } from "@ionic/react";
import { closeCircleOutline } from "ionicons/icons";

import { VarejoAtacadoPromoFloatWindow } from "./VarejoAtacadoModal.styles";
import { useVarejoAtacadoModal } from "./useVarejoAtacadoModal";
import Button from "../../../../../sharable/ActionButton";

export const VarejoAtacadoModal = ({
  isOpen,
  products,
  currentProductId,
  currentProductName,
  isAccountPremium,
  onClose,
  onSave,
}) => {
  const {
    form,
    updateField,
    save,
    canSave,
    isVarejoValid,
    isAtacadoValid,
    atacadoMoreExpensive,
  } = useVarejoAtacadoModal({
    products,
    currentProductId,
    isOpen,
    onSave,
  });

  if (!isOpen) return null;

  return (
    <VarejoAtacadoPromoFloatWindow
      className="flex direction-column"
      isAccountPremium={isAccountPremium}
    >
      <div className="icon-wrapper flex min-gap align" onClick={onClose}>
        <span>Fechar</span>
        <IonIcon icon={closeCircleOutline} className="icon" />
      </div>

      <span className="edit-product-span">
        Editando <strong>'{currentProductName}'</strong>
      </span>

      <h1>Varejo e Atacado</h1>
      <p>Informe os preços para varejo e atacado no formato 0,00.</p>

      <div className="promo-fields-list flex direction-column justify-left">
        <div className="flex direction-column">
          <h2>Preço varejo</h2>
          <input
            onInput={(e) => updateField("varejoPrice", e.target.value)}
            type="text"
            placeholder="Ex: 19,99"
            value={form.varejoPrice}
            className={
              !isVarejoValid && form.varejoPrice ? "invalid-input" : ""
            }
          />
          {!isVarejoValid && form.varejoPrice && (
            <p>Formato inválido. Use o padrão 0,00</p>
          )}
        </div>

        <div className="flex direction-column">
          <h2>Preço atacado</h2>
          <input
            onInput={(e) => updateField("atacadoPrice", e.target.value)}
            type="text"
            placeholder="Ex: 17,99"
            value={form.atacadoPrice}
            className={
              (!isAtacadoValid && form.atacadoPrice) || atacadoMoreExpensive
                ? "invalid-input"
                : ""
            }
          />
          {!isAtacadoValid && form.atacadoPrice && (
            <p>Formato inválido. Use o padrão 0,00</p>
          )}
          {atacadoMoreExpensive && (
            <p>Preço atacado não pode ser maior que o preço varejo</p>
          )}
        </div>
      </div>

      <Button
        color={"#fff"}
        text={"Salvar"}
        width={"35%"}
        $fullWidth={true}
        action={save}
      />

      {!canSave && <p>Corrija os campos para salvar.</p>}
    </VarejoAtacadoPromoFloatWindow>
  );
};
